"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _itemVisitUtils = require("../Menu/itemVisitUtils");
var _DropdownButton = require("./DropdownButton");
var DropdownPresenter = /*#__PURE__*/function () {
  function DropdownPresenter(i18n, omitSelectedOption, suppressInnerEmptyMenu) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, DropdownPresenter);
    (0, _defineProperty2["default"])(this, "calculateLabelOf", function (value) {
      return function (children) {
        return _this.labelFor(children)(value);
      };
    });
    this.i18n = i18n;
    this.omitSelectedOption = omitSelectedOption;
    this.flattenOptions = _itemVisitUtils.getFlattenItems.bind(this);
    this.labelFor = _itemVisitUtils.labelFor.bind(this);
    this.suppressInnerEmptyMenu = suppressInnerEmptyMenu;
  }
  return (0, _createClass2["default"])(DropdownPresenter, [{
    key: "hasValue",
    value: function hasValue(value) {
      if ((0, _isNumber["default"])(value)) return true;
      if (Array.isArray(value)) return !!value.length;
      return !!value;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(value, children, renderValue) {
      return (renderValue === null || renderValue === void 0 ? void 0 : renderValue(value)) || this.renderDefaultLabel(value, children);
    }
  }]);
}();
var _default = exports["default"] = DropdownPresenter;